/**
 * Direção leve da troca hub ↔ seção (classe de animação de entrada).
 * Síncrono no <html data-config-nav> antes do navigate — sem travar a UI.
 */
export function setConfigNavDirection(direction) {
  const dir = direction === 'back' ? 'back' : 'forward';
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.configNav = dir;
  }
}

export function navigateConfig(navigate, path, direction = 'forward') {
  setConfigNavDirection(direction);
  navigate(path);
}
